import cts, { cts_secure } from '_cts';
import apis from '_apis';
import { config, zone } from '_actions';
import { getCollection } from '_helpers';
import store from '../../configureStore';

const { dispatch } = store.store;

const {
  setSchedule,
  setCollection,
} = config;

const {
  setZoneStr,
  setZoneAry,
  setFullAddress,
} = zone;

/**
 * getSchedule information data
 *
 * @param {string} projectId
 * @param {string} districtId
 * @param {string} zone
 * @returns data
 */
export const getSchedule = async (projectId, districtId, zone) => {
  try {
    const { data, status } = await cts_secure('get', apis.getScheduleJson(projectId, districtId, zone));

    if (
      !data
      && status !== 200
    ) throw new Error('Error getting schedule details, in getSchedule function at the utils section.');

    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e.message);
  }
};

/**
 * set Schedule & setCollection
 *
 * @param {string} zone
 * @returns "done"
 */
export const setCollectionSchedule = async (zone) => {
  try {
    const state = store.store.getState();
    const { projectId } = state.plugin;
    const { selectedLang, districtId } = state.config;

    const schedule = await getSchedule(projectId, districtId, zone);

    if (!schedule) throw new Error("Can't get the schedule object, in setCollectionSchedule function at the utils section.");

    dispatch(setSchedule(schedule.DATA));

    const collection = await getCollection(projectId, districtId, zone, selectedLang);

    if (
      !collection
      && !Object.keys(collection).length
    ) throw new Error("Can't get the collection object, in setCollectionSchedule function at the utils section.");

    dispatch(setCollection(collection));

    return Promise.resolve('done');
  } catch (e) {
    return Promise.reject(e.message);
  }
};

/**
 * setZone string & setZone Array & setFullAddress string
 *
 * @param {string} type
 * @param {object} values
 * @param {object || string} relatedProp
 * @returns zoneStr
 */
/** REVIEW COMMENT: REFACTOR THIS FUNCTION */
export const setZone = (type, values, relatedProp, history, prevRoute) => {
  const zoneList = { zoneString: 'zone-', zoneArray: [], fullAddress: '' };

  // zone setup list
  if (type === 'list') {
    // eslint-disable-next-line array-callback-return
    relatedProp.map(({ prompt_id }, index) => {
      const value = values[index][prompt_id].split('@')[1];
      zoneList.zoneString += `${value}-`;
      zoneList.zoneArray.push({ [prompt_id]: value });
      zoneList.fullAddress += `${values[index].label}, `;
    });

    zoneList.zoneString = zoneList.zoneString.slice(0, -1);
    zoneList.fullAddress = zoneList.fullAddress.slice(0, -2);
  } else if (type === 'search') {
    const zoneStr = `zone-${Object.keys(values).map((res) => values[res])}`.split(',').join('-');

    zoneList.zoneArray = values;
    zoneList.zoneString = zoneStr;
    zoneList.fullAddress = relatedProp;
  } else if (type === 'map') {
    const zoneStr = `zone-${values.map((item) => `z${item.zone_id}`)}`.split(',').join('-');

    const zoneAry = values.map(
      (item) => ({ [item.prompt_id]: item.zone_id })
    );

    zoneList.zoneArray = zoneAry;
    zoneList.zoneString = zoneStr;
    zoneList.fullAddress = relatedProp;
  }

  // no need to show confirm zone screen anymore
  // const confirmText = checkConfirmationText(zoneList.zoneString);
  // if (confirmText) return history.push('/zone-setup/confirm-zone',
  // { zoneList, confirmText, prevRoute });

  dispatch(setZoneAry(zoneList.zoneArray));
  dispatch(setZoneStr(zoneList.zoneString));
  dispatch(setFullAddress(zoneList.fullAddress));

  return zoneList.zoneString;
};

// const checkConfirmationText = (zoneStr) => {
//   const state = store.store.getState();
//   const { prompts } = state.zone;

//   const zoneArrayItems = zoneStr.split('-');
//   let confirmationText = '';

//   for (let index = 0; index < prompts.length; index += 1) {
//     if (
//       prompts[index].zones
//       && prompts[index].zones.length
//     ) {
//       for (let item = 0; item < prompts[index].zones.length; item += 1) {
//         if (
//           zoneArrayItems[index + 1] === prompts[index].zones[item].id
//           && prompts[index].zones[item].details
//           && prompts[index].zones[item].details.confirmDscr
//         ) {
//           confirmationText += prompts[index].zones[item].details.confirmDscr;
//         }
//       }
//     }
//   }

//   return confirmationText;
// };

/**
 * get zone information data
 *
 * @param {string} projectId
 * @param {string} districtId
 * @param {number} lat
 * @param {number} lng
 * @returns data
 */
export const getZone = async (
  projectId, districtId, lat, lng
) => {
  try {
    if (
      !lat
      && !lng
    ) throw new Error('There is no correct coordinates found, in getZone function at the utils section.');

    const { data, status } = await cts_secure('get', apis.zoneInfo(projectId, districtId, lat, lng));

    if (
      !data
      && status !== 200
    ) throw new Error('Error fetching to getting zones information, in getZone function at the utils section.');

    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

/**
 * Get the Zone & Call the schedule and collection function
 *
 * @param {string} type
 * @param {object} zoneValue
 * @param {object || string} relatedProp : it could be prompts or
 * full_address, depends on the parent function
 *
 */
/** REVIEW COMMENT: Refactor this function */
export const confirmHandler = async (
  history,
  type,
  zoneValue,
  relatedProp,
  prevRoute,
  setZoneStringBP
) => {
  try {
    // Get the zone
    const state = store.store.getState();
    const { webappConfig } = state.config;
    const {
      has_calendar: hasCalendar, has_wgw: hasWgw
    } = webappConfig || {
      has_calendar: false, has_wgw: false
    };

    // REVIEW COMMENT: Is this a set zone or get zone function????
    const zoneStr = setZone(type, zoneValue, relatedProp, history, prevRoute);

    // Set the schedule and collection
    if (zoneStr) {
      const collectionScheduleStatus = await setCollectionSchedule(zoneStr);

      if (collectionScheduleStatus !== 'done') throw new Error('There was a problem in setting schedule and collections, in confirmHandler function at utils.');

      if (setZoneStringBP) {
        setZoneStringBP(zoneStr);
        return;
      }

      let route = '';
      route = ((!prevRoute || !prevRoute.prevRoute) && hasCalendar) ? '/cal' : '';
      route = ((!prevRoute || !prevRoute.prevRoute) && hasCalendar) ? '/cal' : '';
      route = ((!prevRoute || !prevRoute.prevRoute) && !hasCalendar && hasWgw) ? '/wgw' : '';
      route = ((!prevRoute || !prevRoute.prevRoute) && !hasCalendar && !hasWgw) ? '/resources' : '';
      route = (prevRoute === '/help' || prevRoute.prevRoute === '/help') ? '/help/missed-collections' : '';

      history.push(route);
    }
  } catch (e) {
    Promise.reject(e.message);
  }
};
